import { createSlice } from "@reduxjs/toolkit";
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import BadgeIcon from '@mui/icons-material/Badge';
import SettingsIcon from '@mui/icons-material/Settings';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import BallotIcon from '@mui/icons-material/Ballot';
import CoPresentIcon from '@mui/icons-material/CoPresent';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import LaptopWindowsIcon from '@mui/icons-material/LaptopWindows';
import DevicesIcon from '@mui/icons-material/Devices';
import DesktopWindowsIcon from '@mui/icons-material/DesktopWindows';
import HubIcon from '@mui/icons-material/Hub';
import AppsIcon from '@mui/icons-material/Apps';
import SecurityIcon from '@mui/icons-material/Security';
import ListAltIcon from '@mui/icons-material/ListAlt';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import RouterIcon from '@mui/icons-material/Router';

const organizationSlice = createSlice({
    name: 'organization',
    initialState: [ 
        {
            id: 'hospital' ,
            Label: 'Hospital',
            options: [
                {
                    id: 'dashboard',
                    Label: 'MODULES',
                    icon: <DashboardCustomizeIcon />,
                    to: '/home',
                    menu: [
                        {
                            id: 'Dashboard',
                            Label: 'Dashboard',
                            to: '/home',
                            icon: <DashboardCustomizeIcon />
                        }
                    ]
                },
                {
                    id: 'MFA Control',
                    Label: 'MFA CONTROL',
                    icon: <BadgeIcon />,
                    menu: [
                        {
                            id: 'Devices',
                            Label: 'Devices',
                            to: '/devices',
                            icon: <DevicesIcon />
                        },
                        {
                            id: 'Windows Agent Devices',
                            Label: 'Windows Agent Devices',
                            to: '/windows-agent-devices',
                            icon: <DesktopWindowsIcon />
                        },
                        // Retired: AD sync now runs through the gateway page
                        // {
                        //     id: 'AD Integration',
                        //     Label: 'AD Integration',
                        //     to: '/admin/ad-integration',
                        //     icon: <HubIcon />
                        // },
                        {
                            id: 'Applications',
                            Label: 'Applications',
                            to: '/applications',
                            icon: <AppsIcon />
                        }
                    ]
                },
                {
                    id: 'User Settings',
                    Label: 'USER SETTINGS',
                    icon: <SupervisorAccountIcon />,
                    menu: [
                        {
                            id: 'Role Master',
                            Label: 'Role',
                            to: '/role',
                            icon: <SecurityIcon />
                        },
                        {
                            id: 'User Management',
                            Label: 'User Management',
                            to: '/user-management',
                            icon: <ListAltIcon />
                        }
                    ]
                },
                {
                    id: 'SCIM Integrations',
                    Label: 'SCIM INTEGRATIONS',
                    icon: <SyncAltIcon />,
                    to: '/admin/scim',
                    menu: [
                        {
                            id: 'Connections',
                            Label: 'Connections',
                            to: '/admin/scim',
                            icon: <SyncAltIcon />
                        }
                    ]
                },
                {
                    id: 'Gateway Monitoring',
                    Label: 'GATEWAY MONITORING',
                    icon: <RouterIcon />,
                    to: '/admin/gateways',
                    menu: [
                        {
                            id: 'Gateways',
                            Label: 'Gateways',
                            to: '/admin/gateways',
                            icon: <RouterIcon />
                        }
                    ]
                }
            ]
        }
    ]
});

export default organizationSlice.reducer;